import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { useAuth } from '../../hooks/useAuth';
import { isLoggedInState } from '../../storage/app';
import useEffectOnce from '../../hooks/useEffectOnce';

export function AuthProvider() {
  const isLoggedIn = useRecoilValue(isLoggedInState);
  const navigate = useNavigate();
  const { initApp } = useAuth();

  useEffectOnce(() => {
    initApp();
  });

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/login', { replace: true });
    }
  }, [isLoggedIn]);

  return null;
}
